export default function divideOnPages(arr, count) {
  return [
    ...arr.reduce(
      (pages, e, index) => (index % count ? pages[pages.length - 1].push(e) : pages.push([e])) && pages,
      []
    ),
  ];
}
